"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const versioned = [{
  minmax: [0, undefined],
  types: {
    TokenSymbol: {
      _enum: {
        BNC: 1,
        KUSD: 2,
        KSM: 4,
        KAR: 6
      }
    }
  }
}];
var _default = versioned;
exports.default = _default;